import type { NapiV2Purchase } from "@app/types/napi-v2-purchase-types";

export const getPurchaseTicketBundle = (purchase: NapiV2Purchase) => {
  return purchase.ticket_bundle;
};
